// extracted by mini-css-extract-plugin
module.exports = {"item":"HowWeWorkItem_item__oFamk","icon":"HowWeWorkItem_icon__NEJng","title":"HowWeWorkItem_title__oRtLg","text":"HowWeWorkItem_text__BZeOK"};